import * as swcHelpers from '@swc/helpers';

const toInsurancePrice = (price)=>{
    return swcHelpers.objectSpread({}, price);
};
const getInsurance = (insurance)=>{
    if (!insurance) {
        return;
    }
    var _policyNumber;
    return insurance ? {
        sku: insurance.sku,
        name: insurance.name,
        id: insurance.id,
        price: {
            total: toInsurancePrice(insurance.price.total),
            unit: toInsurancePrice(insurance.price.unit)
        },
        policyNumber: (_policyNumber = insurance.policyNumber) !== null && _policyNumber !== void 0 ? _policyNumber : undefined
    } : undefined;
};

export { getInsurance };
//# sourceMappingURL=get-insurance.js.map
